import { colors, spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { Pressable, PressableProps } from 'react-native';

export const InfoButton = (
  props: Omit<PressableProps, 'children'> & { iconSize?: number }
) => (
  <Pressable {...props} hitSlop={spacing[1]}>
    <FontAwesomeIcon size={props.iconSize ?? 20} color={colors.primary[70]} icon="circle-info" />
  </Pressable>
);
